import { apiSlice } from '../app/api/apiSlice';

export const resourcesApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({

    getResources: builder.query({
      query: ()=>({
        url: 'Resources',
        method: 'get',
      }),
      providesTags: ['Resources'],
    }),

    createResource: builder.mutation({
      query: (newResource)=>({
        url: 'resources',
        method: 'post',
        body: newResource
      }),
      invalidatesTags: ["Resources"]
    }),

    updateResource: builder.mutation({
        query: (resource)=>({
            url: `resources/${(resource instanceof FormData) ? (resource.get("id")) : resource.id }`,
            method: 'put',
            body: resource
        }),
        invalidatesTags: ["Resources"]
    }),

    deleteResource: builder.mutation({
        query: (resourceId)=>({
            url: `resources/${resourceId}`,
            method: 'delete'
        }),
        invalidatesTags: ["Resources"]
    }),

    sortResources: builder.mutation({
      query: (sortList)=>({
          url: `resources/sort`,
          method: 'put',
          body: sortList
      }),
      invalidatesTags: ["Resources"]
    }),

    getResourcesHeaders: builder.query({
      query: ()=>({
        url: 'resources/headers',
        method: 'get',
      }),
      providesTags: ['ResourcesHeaders'],
    }),
    createResourceHeader: builder.mutation({
      query: (newResourceHeader)=>({
        url: 'resources/headers',
        method: 'post',
        body: newResourceHeader
      }),
      invalidatesTags: ["ResourcesHeaders"]
    }),
    deleteResourceHeader: builder.mutation({
      query: (resourceHeaderId)=>({
          url: `resources/headers/${resourceHeaderId}`,
          method: 'delete'
      }),
      invalidatesTags: ["ResourcesHeaders"]
    }),
    updateResourceHeader: builder.mutation({
      query: (resourceHeader)=>({
          url: `resources/headers/${resourceHeader.id}`,
          method: 'put',
          body: resourceHeader
      }),
      invalidatesTags: ["ResourcesHeaders"]
    }),
    sortResourcesHeaders: builder.mutation({
      query: (sortList)=>({
          url: `resources/headers/sort`,
          method: 'put',
          body: sortList
      }),
      invalidatesTags: ["ResourcesHeaders"]
    }),
  })
})

export const { 
    useCreateResourceMutation, 
    useGetResourcesQuery,
    useUpdateResourceMutation,
    useDeleteResourceMutation,
    useSortResourcesMutation,

    useGetResourcesHeadersQuery,
    useCreateResourceHeaderMutation,
    useLazyGetResourcesHeadersQuery,
    useDeleteResourceHeaderMutation,
    useUpdateResourceHeaderMutation,
    useSortResourcesHeadersMutation
} = resourcesApi;